<template>
  <div>
    <el-input v-model="phone"></el-input>
    <el-button type="primary" @click="submit">11</el-button>
  </div>

</template>

<script>
export default {
  data(){
    return{
      phone:''
    }
  },
  methods:{
    submit(){

    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/WxBindPhone.vue